import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import separatorClasses from './Separator.module.scss';

export default function Separator({ className, color = 'grey-200' }) {
  const cn = cx(
    separatorClasses.separator,
    { [separatorClasses[`color-${color}`]]: color !== undefined },
    className,
  );

  return <hr className={cn} />;
}

Separator.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf(['secondary', 'accent', 'grey-200']),
};
